export default __webpack_public_path__ + "static/media/arrowUp.08c2b7cd.svg";